import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link, SxProps, Theme } from '@mui/material';
import React from 'react';

type NewTabLinkProps = {
  href: string;
  label: React.ReactNode;
  sx?: SxProps<Theme>;
  dataCy?: string;
};

const NewTabLink: React.FC<NewTabLinkProps> = ({ href, label, sx, dataCy }) => (
  <Link
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-cy={dataCy}
    sx={[
      { display: 'inline-flex', alignItems: 'center', gap: 0.5, color: 'primary.main', textDecoration: 'underline' },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {label}
    <OpenInNewIcon sx={{ fontSize: '1em' }} />
  </Link>
);

export default NewTabLink;
